import React, { ReactNode } from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  normalizeSupportedLanguage,
} from "../language/supportedLanguages";
import Navigation from "../components/Layout/Navigation";
import { siteLinks } from "../components/Layout/siteLinks";
import { useAppSelector } from "../store/hooks";

interface Props {
  children?: ReactNode;
}

const Layout: React.FunctionComponent<Props> = ({ children }: Props) => {
  const error = useAppSelector((rootState) => rootState.error);
  const loadNav = true; // (process.env.REACT_APP_IS_IN_IFRAME !== 'true');
  const { i18n } = useTranslation();
  const currentLanguage = normalizeSupportedLanguage(i18n.language);
  const footerLinks = siteLinks[currentLanguage].footerLinks;

  return (
    <>
      {loadNav ? <Navigation /> : null}
      <main>
        {error.errorMsg ? (
          <div className="container-md">
            <Alert className="mt-4" variant="danger">
              <div dangerouslySetInnerHTML={{ __html: error.errorMsg }}></div>
            </Alert>
          </div>
        ) : (
          children
        )}
      </main>
      <footer>
        <div className="container-md">
          <div className="col-12">
            <div className="footer-legal">
              <strong>
                {footerLinks.map((link, index) => (
                  <React.Fragment key={link.href}>
                    {index > 0 ? " | " : null}
                    <a href={link.href}>{link.label}</a>
                  </React.Fragment>
                ))}
              </strong>{" "}
              &ndash; &copy; esg2go {new Date().getFullYear()}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Layout;
